export const SET_CUSTOMERS = 'SET_CUSTOMERS';
export const REMOVE_CUSTOMERS = 'REMOVE_CUSTOMERS';
export const ADD_CUSTOMERS = 'ADD_CUSTOMERS';
export const UPDATE_CUSTOMERS = 'UPDATE_CUSTOMERS';
